import { Box, CircularProgress, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Alert, AlertTitle } from '@material-ui/lab';
import { Layout, UserStore, useQuery, useUserStore } from '@roc/feature-app-core';
import {
  DialogState,
  EditableDialog,
  StandardDialog,
  Button,
  createTextField,
  TextField,
  AutocompleteAddressField,
  AutocompleteField,
} from '@roc/ui';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { useAppraisalsStore, useInternalSecondAppraisalStore } from '../hooks';
import { SecondAppraisalStep } from '../stores';
import {
  SecondAppraisalError,
  SecondAppraisalForm,
  SecondAppraisalLinkSuccessAlreadyPaid,
  SecondAppraisalPaidInAdvance,
  SecondAppraisalSuccess,
} from './SecondAppraisalForm';

const useStyles = makeStyles({
  '@global': {
    body: {
      backgroundColor: 'transparent !important',
    },
  },
  instruction: {
    fontWeight: 600,
  },
  paymentDetails: {
    fontWeight: 800,
    marginTop: '20px',
    fontStyle: 'italic',
  },
  tabsContainer: {
    border: 'none !important',
    marginTop: '-35px',
  },
  container: {
    paddingTop: 12,
  },
  closeButtonContainer: {
    paddingTop: 16,
  },
  button: {
    width: '100%',
  },
});

export const SecondAppraisalModal = observer(() => {
  const classes = useStyles();
  const { loanId } = useParams<{ loanId: string }>();
  const { internalSecondAppraisalStore } = useInternalSecondAppraisalStore();
  const [showGenerateLinkButton, setShowGenerateLinkButton] = useState(true);
  const [
    openSecondAppraisalModal,
    setopenSecondAppraisalModal,
  ] = useState<boolean>(false);
  const { step } = internalSecondAppraisalStore;

  const {userStore} = useUserStore();

  useEffect(() => {
    userStore.getUserInfoAndEntitlements();
    internalSecondAppraisalStore.fetchLoanPropertiesAndCheckStatus(loanId);
  }, []);

  const closeSecondAppraisalModal = () => {
    setopenSecondAppraisalModal(false);
    window.parent.postMessage({ action: 'close-modal' }, '*');
  };

  const query = useQuery();

  useEffect(() => {
    if (query.get('openModal') === 'true') {
      setopenSecondAppraisalModal(true);
      window.parent.postMessage({ action: 'modal-ready' }, '*');
    }
  }, [query]);

  const isRentalPortfolio = () => {
    return 'Rental Portfolios' === internalSecondAppraisalStore.loanSubtype;
  }

  return (
    <Layout maxWidth="lg">
      <Grid container spacing={2} style={{ width: '100%' }}>
        <StandardDialog
          title="Order Second Appraisal"
          open={openSecondAppraisalModal}
          onClose={closeSecondAppraisalModal}
          handleClose={closeSecondAppraisalModal}
          removeContentBox
          dialogContent={
            <Box width="100%">
              {(step === SecondAppraisalStep.SELECT_PROPERTY) && (
                <SecondAppraisalForm />
              )}
              {step === SecondAppraisalStep.ERROR && <SecondAppraisalError />}
              {step === SecondAppraisalStep.ALREADY_PAID && (
                <SecondAppraisalPaidInAdvance />
              )}
              {step === SecondAppraisalStep.SUCCESS && (
                <SecondAppraisalSuccess />
              )}
              {step === SecondAppraisalStep.SUCCESS_ALREADY_PAID && (
                <SecondAppraisalLinkSuccessAlreadyPaid />
              )}
              {step === SecondAppraisalStep.ORDER_CREATED && (
                <SecondAppraisalPaidInAdvance />
              )}
            </Box>
          }
          dialogActions={
            <Grid
              container
              spacing={2}
              xs={12}
              justifyContent="flex-end"
              className={classes.closeButtonContainer}
            >
              <Grid item>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={closeSecondAppraisalModal}
                  testId="cancel"
                >
                  Close
                </Button>
              </Grid>
              {step === SecondAppraisalStep.SELECT_PROPERTY && showGenerateLinkButton && (
                <Grid item>
                  <Button
                    onClick={() => {
                      internalSecondAppraisalStore.orderSecondAppraisal(
                        loanId,
                        false
                      );
                    }}
                    variant="contained"
                    color="primary"
                    testId="close"
                  >
                    Generate Link
                  </Button>
                </Grid>
              )}
              {(internalSecondAppraisalStore.allowOrderSecondAppraisal && step === SecondAppraisalStep.ALREADY_PAID) && (
                <Grid item>
                  <Button
                    onClick={() => {
                      internalSecondAppraisalStore.orderSecondAppraisal(
                        loanId,
                        true
                      );
                    }}
                    variant="contained"
                    color="primary"
                    testId="close"
                  >
                    Place Order
                  </Button>
                </Grid>
              )}
            </Grid>
          }
        ></StandardDialog>
      </Grid>
    </Layout>
  );
});